import React, { useEffect } from 'react';
import './Header.scss';

const Header = () => {
  useEffect(() => {
    // Smart Sticky Header
    let lastScrollTop = 0;
    const header = document.querySelector('header');
    
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        // Aşağı kaydırma - header'ı gizle
        header.classList.add('header-hidden');
        header.classList.remove('header-visible');
      } else if (scrollTop < lastScrollTop) {
        // Yukarı kaydırma - header'ı göster
        header.classList.remove('header-hidden');
        header.classList.add('header-visible');
      }
      
      // Sayfa en üstteyse shadow'ı kaldır
      if (scrollTop <= 10) {
        header.classList.remove('header-visible');
        header.classList.remove('header-hidden');
      }

      // Active menu link detection
      const sections = document.querySelectorAll('section[id]');
      const navLinks = document.querySelectorAll('nav a[href^="#"]');
      
      let currentSection = '';
      const headerHeight = header.offsetHeight;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Eğer sayfa sonuna yakınsa (footer alanında) direkt "iletisim" aktif yap
      if (scrollTop + windowHeight >= documentHeight - 1000) {
        currentSection = 'iletisim';
      } else if (scrollTop <= 200) {
        // Sayfa en üstteyse default olarak "bizkimiz" aktif
        currentSection = 'bizkimiz';
      } else {
        // Normal section detection
        for (let i = sections.length - 1; i >= 0; i--) {
          const section = sections[i];
          const sectionTop = section.offsetTop - headerHeight - 100;
          
          if (scrollTop >= sectionTop) {
            currentSection = section.getAttribute('id');
            break;
          }
        }
      }

      // Remove active class from all nav links
      navLinks.forEach(link => {
        link.classList.remove('active');
      });

      // Add active class to current section link
      if (currentSection) {
        const activeLink = document.querySelector(`nav a[href="#${currentSection}"]`);
        if (activeLink) {
          activeLink.classList.add('active');
        }
      }
      
      lastScrollTop = scrollTop;
    };

    window.addEventListener('scroll', handleScroll);

    // Smooth scroll for all anchor links with hash
    const navLinks = document.querySelectorAll('a[href^="#"]');
    
    const handleSmoothScroll = (e) => {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        const headerHeight = header.offsetHeight;
        const targetPosition = targetElement.offsetTop - headerHeight - 20; // 20px extra padding
        
        // Custom smooth scroll with slower speed
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        const duration = 1800; // 1.8 saniye (çok daha yavaş)
        let start = null;

        const step = (timestamp) => {
          if (!start) start = timestamp;
          const progress = timestamp - start;
          const percentage = Math.min(progress / duration, 1);
          
          // Easing function for smoother animation
          const easeInOutCubic = percentage < 0.5 
            ? 4 * percentage * percentage * percentage 
            : (percentage - 1) * (2 * percentage - 2) * (2 * percentage - 2) + 1;
          
          window.scrollTo(0, startPosition + distance * easeInOutCubic);
          
          if (progress < duration) {
            requestAnimationFrame(step);
          }
        };

        requestAnimationFrame(step);

        // Mobile menüyü kapat
        const nav = document.querySelector('nav');
        const mobileToggle = document.querySelector('.mobile-menu-toggle');
        if (nav && nav.classList.contains('active')) {
          nav.classList.remove('active');
          mobileToggle.classList.remove('active');
          document.body.classList.remove('menu-open');
        }
      }
    };

    navLinks.forEach(link => {
      link.addEventListener('click', handleSmoothScroll);
    });

    // Logo smooth scroll to top
    const logoLink = document.querySelector('.logo a');
    
    const handleLogoClick = (e) => {
      e.preventDefault();
      
      // Smooth scroll to top with custom animation
      const startPosition = window.pageYOffset;
      const duration = 1800; // Aynı hızda (menü linkleri ile tutarlı)
      let start = null;

      const step = (timestamp) => {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const percentage = Math.min(progress / duration, 1);
        
        // Easing function
        const easeInOutCubic = percentage < 0.5 
          ? 4 * percentage * percentage * percentage 
          : (percentage - 1) * (2 * percentage - 2) * (2 * percentage - 2) + 1;
        
        window.scrollTo(0, startPosition * (1 - easeInOutCubic));
        
        if (progress < duration) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);

      // Mobile menüyü kapat
      const nav = document.querySelector('nav');
      const mobileToggle = document.querySelector('.mobile-menu-toggle');
      if (nav && nav.classList.contains('active')) {
        nav.classList.remove('active');
        mobileToggle.classList.remove('active');
        document.body.classList.remove('menu-open');
      }
    };

    if (logoLink) {
      logoLink.addEventListener('click', handleLogoClick);
    }

    // Mobile menu toggle
    const mobileToggle = document.querySelector('.mobile-menu-toggle');
    const nav = document.querySelector('nav');
    const searchIcon = document.querySelector('.header-icons a');
    const searchOverlay = document.querySelector('.search-overlay');
    const closeSearch = document.querySelector('.close-search');

    if (mobileToggle && nav) {
      const handleMobileToggle = () => {
        mobileToggle.classList.toggle('active');
        nav.classList.toggle('active');
        document.body.classList.toggle('menu-open');
      };
      
      mobileToggle.addEventListener('click', handleMobileToggle);
      
      return () => {
        mobileToggle.removeEventListener('click', handleMobileToggle);
      };
    }

    // Search overlay
    if (searchIcon && searchOverlay) {
      const handleSearchOpen = (e) => {
        e.preventDefault();
        searchOverlay.classList.add('active');
        setTimeout(() => {
          const searchInput = searchOverlay.querySelector('input');
          if (searchInput) searchInput.focus();
        }, 50);
      };

      searchIcon.addEventListener('click', handleSearchOpen);
      
      return () => {
        searchIcon.removeEventListener('click', handleSearchOpen);
      };
    }

    // Close search
    if (closeSearch && searchOverlay) {
      const handleSearchClose = () => {
        searchOverlay.classList.remove('active');
      };

      closeSearch.addEventListener('click', handleSearchClose);
      
      // ESC key close
      const handleEscKey = (e) => {
        if (e.key === 'Escape') {
          searchOverlay.classList.remove('active');
        }
      };

      document.addEventListener('keydown', handleEscKey);
      
      return () => {
        closeSearch.removeEventListener('click', handleSearchClose);
        document.removeEventListener('keydown', handleEscKey);
        window.removeEventListener('scroll', handleScroll);
      };
    }

    // Cleanup scroll event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
      navLinks.forEach(link => {
        link.removeEventListener('click', handleSmoothScroll);
      });
      if (logoLink) {
        logoLink.removeEventListener('click', handleLogoClick);
      }
    };
  }, []);

  return (
    <>
      <header>
        <div className="container">
          <div className="logo">
            <a href="/"><img src="logos/hatay-finetch-logo.svg" alt="Hayat Fintech Logo" /></a>
          </div>
          <button className="mobile-menu-toggle">
            <img src="icons/hamburger.svg" alt="Menu" className="menu-icon" />
            <img src="icons/close.svg" alt="Close" className="close-icon" />
          </button>
          <nav>
            <ul>
              <li><a href="#bizkimiz" className="active">Biz Kimiz</a></li>
              <li><a href="#tecrubeuzmanlik">Hizmetlerimiz</a></li>
              <li><a href="#onceliklerimiz">Önceliklerimiz</a></li>
              <li><a href="#iletisim">İletişim</a></li>
            </ul>
            <div className="mobile-lang-accordion">
              <button className="lang-accordion-toggle">
                <div className="lang-info">
                  <img src="icons/world.svg" alt="Language" />
                  <span>TR</span>
                </div>
                <img src="icons/chevron.svg" alt="Toggle" className="toggle-arrow" />
              </button>
              <div className="lang-accordion-content">
                <ul>
                  <li><a href="?lang=tr">EN</a></li>
                </ul>
              </div>
            </div>
          </nav>
                      <div className="header-icons">
              <button type="button" className="search-btn"><img src="icons/search.svg" alt="Search" /></button>
            <div className="lang-selector">
              <img src="icons/world.svg" alt="Language" />
              <span>TR</span>
            </div>
          </div>
        </div>
      </header>
      
      <div className="search-overlay">
        <div className="container">
          <div className="search-form">
            <input type="text" placeholder="Ne aramıştınız?" />
          </div>
          <button className="close-search">
            <img src="icons/close.svg" alt="Close" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;
 